if (!customElements.get('product-description-read-more')) {
  customElements.define(
    'product-description-read-more',
    class ProductDescriptionReadMore extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._userToggled = false;
        this._fullHeight = 0;

        this.innerEl = this.querySelector('.product__description-inner');
        this.button = this.querySelector('.product__description-toggle');
        this.labelMore = this.querySelector('.product__description-toggle-label--more');
        this.labelLess = this.querySelector('.product__description-toggle-label--less');
        if (!this.innerEl || !this.button) return;

        this.button.addEventListener('click', () => this.toggle());

        const init = () => requestAnimationFrame(() => this.measure());

        if (document.readyState === 'complete') {
          init();
        } else {
          window.addEventListener('load', init, { once: true });
        }

        document.addEventListener('shopify:section:load', this._onSectionLoad);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
      }

      _onSectionLoad = (e) => {
        if (e.target?.contains?.(this)) {
          this._userToggled = false;
          requestAnimationFrame(() => this.measure());
        }
      };

      getCollapsedMaxPx() {
        const raw = getComputedStyle(this).getPropertyValue('--read-more-lines').trim();
        const n = Math.max(parseInt(raw, 10) || 4, 1);
        if (!this.innerEl) return n * 26;

        const cs = getComputedStyle(this.innerEl);
        let lh = parseFloat(cs.lineHeight);
        if (!Number.isFinite(lh) || lh <= 0 || cs.lineHeight === 'normal') {
          lh = (parseFloat(cs.fontSize) || 16) * 1.65;
        }
        return n * lh;
      }

      measure() {
        if (!this.innerEl || !this.button) return;

        const wasCollapsed = this.classList.contains('is-collapsed');
        this.classList.remove('is-collapsed');
        this.innerEl.style.maxHeight = 'none';
        void this.innerEl.offsetHeight;

        this._fullHeight = this.innerEl.scrollHeight;
        const maxPx = this.getCollapsedMaxPx();

        this.innerEl.style.maxHeight = '';

        if (this._fullHeight <= maxPx + 2) {
          this.classList.remove('is-collapsed');
          this.button.hidden = true;
          this.button.setAttribute('aria-expanded', 'true');
          this.labelMore?.classList.add('hidden');
          this.labelLess?.classList.add('hidden');
          return;
        }

        this.style.setProperty('--read-more-full-height', this._fullHeight + 'px');
        this.classList.add('is-collapsed');
        this.button.hidden = false;
        this.button.setAttribute('aria-expanded', 'false');
        this.labelMore?.classList.remove('hidden');
        this.labelLess?.classList.add('hidden');
      }

      toggle() {
        if (this.button.hidden) return;
        this._userToggled = true;

        const expanding = this.classList.contains('is-collapsed');
        this.classList.toggle('is-collapsed', !expanding);
        this.button.setAttribute('aria-expanded', expanding ? 'true' : 'false');
        this.labelMore?.classList.toggle('hidden', expanding);
        this.labelLess?.classList.toggle('hidden', !expanding);
      }
    }
  );
}
